import { TICKET_TYPES as TYPES } from '../../../../constants';

export const SUBTYPES = {
  NEW: 'new',
  REFUSAL: 'refusal',
  ORDER: 'order',
  CANCELATION: 'cancelation',
  TOUR: 'tour',
  EXTRAS: 'extras',
  CONFLICT: 'conflict',
  RESTING: 'in_resting',
};

export const TITLES = {
  [TYPES.COMMON_QUESTION]: 'Общие воп.',
  [TYPES.TOUR_SELECTION]: 'Подбор тура',
  [TYPES.UNKNOWN]: 'Нет типа',
  [TYPES.UPDATING]: 'Изменение',
  [TYPES.HOTLINE]: 'Горячая лин.',
  [SUBTYPES.NEW]: 'Новый',
  [SUBTYPES.REFUSAL]: 'По отказу',
  [SUBTYPES.ORDER]: 'Заказа',
  [SUBTYPES.CANCELATION]: 'Аннуляция',
  [SUBTYPES.TOUR]: 'По туру',
  [SUBTYPES.EXTRAS]: 'Доп услуги',
  [SUBTYPES.CONFLICT]: 'Конфликт',
  [SUBTYPES.RESTING]: 'На отдыхе',
};
